export function PagePlaceholder({
  eyebrow,
  title,
  lede,
}: {
  eyebrow: string;
  title: string;
  lede: string;
}) {
  return (
    <div>
      <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-fg-link">
        {eyebrow}
      </div>
      <h1 className="mt-1 text-[30px] font-bold text-fg-1">{title}</h1>
      <p className="mt-2 max-w-2xl text-fg-2">{lede}</p>
      <div className="mt-8 rounded-lg border border-dashed border-border-2 bg-white p-8 text-center text-sm text-fg-3">
        Coming together in a later phase.
      </div>
    </div>
  );
}
